import { parse } from "query-string";
import { useLocation } from "react-router-dom";
import { formatUrl } from "utils";

import config from "config";
import { CompanyParams, CompleteQueryParams, api } from "config/urls";

const useCompleteRedirect = ({
  companyId,
  sourceType,
  statusCode,
}: CompleteQueryParams & { companyId: string }): (() => void) => {
  const location = useLocation();

  return () => {
    window.location.assign(
      config.LINK_API_URL +
        formatUrl<CompanyParams, CompleteQueryParams>(
          api.companies.complete,
          {
            companyId,
          },
          {
            ...parse(location.search),
            sourceType,
            statusCode,
          }
        )
    );
  };
};

export default useCompleteRedirect;
